// @flow

export function registerParameter(_containerObject: Object, _scope: Array<string>, _name: string, _description: ?Object, _changeValueCallback: ?Function) {
}

export function registerButton(_scope: Array<string>, _buttonTitle: string, _onClick: Function) {
}

export class TrackedParameters {
    registerParameter(_containerObject: Object, _scope: Array<string>, _name: string, _description: ?Object, _changeValueCallback: ?Function) { }

    registerButton(_scope: Array<string>, _buttonTitle: string, _onClick: Function) { }
}
